<template>
    <section>
        <div class="banner_box">
            <!-- <img src="../../assets/APPdownload/banner_app.png" alt=""> -->
            <div class="banner_content">
                <div class="phone_box">
                    <img src="../../assets/APPdownload/phone.png" alt="">
                </div>
                <div class="download_box">
                    <p class="title">海马行</p>
                    <p class="advertise">无卡加油、在线充值、积分兑换、时时查账</p>
                    <p class="good">3分钟完成加油，实现加油不排队。还能通过APP支付享受加油站推出的各种优惠活动，享受超低的油价和便捷支付服务。</p>
                    <a href="https://sj.qq.com/myapp/search.htm?kw=海马行">
                        <div class="download_btn">用户端下载</div>
                    </a>
                </div>
            </div>
        </div>
        <div>
            <div class="type_box">
                <div class="item" @mouseenter.capture="mouseEnter1" @mouseout="mouseOut1">
                    <div class="img_box">
                        <img src="../../assets/APPdownload/jfsc.png" alt="">
                    </div>
                    <p>积分商城</p>
                    <div class="hover_box" v-show="hover_in1">专属会员奖励计划，会员积分、小游戏，玩法多样，积分商城兑换好礼</div>
                </div>
                <div class="item" @mouseenter.capture="mouseEnter2" @mouseout="mouseOut2">
                    <div class="img_box">
                        <img src="../../assets/APPdownload/czjy.png" alt="">
                    </div>
                    <p>车主加油</p>
                    <div class="hover_box hover_box2" v-show="hover_in2">一键加油，方便快捷，告别加油站排队等待</div>
                </div>
                <div class="item" @mouseenter.capture="mouseEnter3" @mouseout="mouseOut3">
                    <div class="img_box">
                        <img src="../../assets/APPdownload/sqsq.png" alt="">
                    </div>
                    <p>社区商圈</p>
                    <div class="hover_box" v-show="hover_in3">以油站为中心的社区商户异业联盟，周边好店推荐及优惠产品和服务</div>
                </div>
                <div class="item" @mouseenter.capture="mouseEnter4" @mouseout="mouseOut4">
                    <div class="img_box">
                        <img src="../../assets/APPdownload/map.png" alt="">
                    </div>
                    <p>地图导航</p>
                    <div class="hover_box hover_box2" v-show="hover_in4">附近加油站信息快速查询，导航直达加油站</div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
    export default {
        data() {
            return {
                hover_in1: false,
                hover_in2: false,
                hover_in3: false,
                hover_in4: false,
            }
        },
        methods: {
            mouseEnter1(){
                this.hover_in1 = true;
            },
            mouseOut1(){
                this.hover_in1 = false;
            },
            mouseEnter2(){
                this.hover_in2 = true;
            },
            mouseOut2(){
                this.hover_in2 = false;
            },
            mouseEnter3(){
                this.hover_in3 = true;
            },
            mouseOut3(){
                this.hover_in3 = false;
            },
            mouseEnter4(){
                this.hover_in4 = true;
            },
            mouseOut4(){
                this.hover_in4 = false;
            },
        },
    }
</script>
<style scoped>
    .banner_box{
        position: relative;
        height: 624px;
        background-image: url(../../assets/APPdownload/banner_app.jpg);
        background-repeat: no-repeat;
        background-size: 100% 100%;
    }
    .banner_box img{
        width: 100%;
        height: 100%;
        vertical-align: bottom;
    }
    .banner_content{
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        width: 1200px;
        margin: 0 auto;
        height: 100%;
    }
    .phone_box{
        position: absolute;
        top: 80px;
        left: 0;
    }
    .download_box{
        position: absolute;
        top: 114px;
        right: 0;
        width: 723px;
        height: 378px;
        background-color: rgba(255, 255, 255, 0.14);
        padding: 50px 88px;
        text-align: left;
        color: #fff;
    }
    .title{
        font-size: 40px;
        margin-bottom: 26px;
    }
    .advertise{
        color: #0069be;
        font-size: 18px;
        margin-bottom: 42px;
    }
    .good{
        font-size: 16px;
        margin-bottom: 32px;
    }
    .download_btn{
        width: 200px;
        height: 48px;
        background: #fff;
        border-radius: 5px;
        color: #0069be;
        text-align: center;
        line-height: 48px;
        font-size: 18px;
    }
    .type_box{
        width: 1200px;
        margin: 64px auto;
    }
    .item{
        position: relative;
        display: inline-block;
        vertical-align: top;
        width: 282px;
        height: 193px;
        color: #0094eb;
        line-height: 32px;
        font-size: 16px;
    }
    .item:nth-child(2) div img{
        padding-top: 12px;
        /* background-color: #0094eb;
        color: #fff;
        padding: 64px 46px 0; */
    }
    .item:last-child div img{
        padding-top: 18px;
    }
    .item .img_box{
        height: 150px;
    }
    .item .hover_box{
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: #0094eb;
        color: #fff;
        padding-top: 46px;
        padding-left: 46px;
        padding-right: 46px;
    }
    .item .hover_box2{
        padding-top: 64px;
    }
</style>
